/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Guardians} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  guardians: Guardians
}

const InfoCell: FC<Props> = ({guardians}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(guardians.id)
  }

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='d-flex flex-column'>
        <a
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {guardians.name}
        </a>
      </div>
    </div>
  )
}

export {InfoCell}
